import { CheckCircle2, Camera, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { seqDeFolio } from "./constants";

// Confirmación de recepción con secuencial gigante (presentacional puro).
export const ReciboSuccessModal = ({ successOpen, setSuccessOpen, recibo, setRecibo, setPhotoDefaultTipo, setPhotoTarget, imprimirTicketValet }) => (
  <Dialog open={successOpen} onOpenChange={(o) => { if (!o) { setSuccessOpen(false); setRecibo(null); } }}>
    <DialogContent className="rounded-none border-[#10B981]/40 bg-[#0A0A0A] text-white max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="valet-success-modal">
      <DialogHeader>
        <div className="h-12 w-12 bg-[#10B981]/15 border border-[#10B981]/40 flex items-center justify-center mb-2">
          <CheckCircle2 className="h-6 w-6 text-[#10B981]" />
        </div>
        <DialogTitle className="font-display font-black text-white text-xl">¡Vehículo Registrado con Éxito!</DialogTitle>
        <DialogDescription className="text-white/50">Entrega este número al cliente para recuperar su vehículo.</DialogDescription>
      </DialogHeader>
      {recibo && (
        <div className="text-center py-2">
          <p className="text-[10px] uppercase tracking-[0.2em] text-white/40 font-bold">Turno #</p>
          <p className="font-display font-black text-[#FFCC00] leading-none" style={{ fontSize: "5.5rem" }} data-testid="valet-success-secuencial">{seqDeFolio(recibo.folio_impreso)}</p>
          <p className="text-sm font-mono text-white/60 mt-1" data-testid="valet-success-folio">{recibo.folio_impreso}</p>
          <div className="mt-4 border-t border-white/10 pt-3 text-sm text-white/70">
            {(recibo.placa || recibo.marca_modelo)
              ? <p>{[recibo.placa, recibo.marca_modelo].filter(Boolean).join(" · ")}</p>
              : <p className="text-white/40">Sin datos del vehículo</p>}
          </div>
        </div>
      )}
      <div className="flex flex-col gap-2 pt-2">
        <button onClick={() => { if (recibo) { setPhotoDefaultTipo("Objetos de Valor"); setPhotoTarget(recibo); } }} data-testid="valet-success-evidencia-btn"
          className="btn-hard w-full h-11 bg-[#6366F1]/15 border border-[#6366F1] text-[#A5B4FC] font-bold uppercase tracking-wider flex items-center justify-center gap-2 hover:bg-[#6366F1]/25">
          <Camera className="h-4 w-4" /> Agregar Evidencia (Objetos / Daños)
        </button>
        <button onClick={() => imprimirTicketValet(recibo)} data-testid="valet-imprimir-btn"
          className="btn-hard w-full h-11 bg-white/5 border border-white/20 text-white font-bold uppercase tracking-wider flex items-center justify-center gap-2 hover:bg-white/10">
          <Printer className="h-4 w-4" /> Imprimir Comprobantes
        </button>
        <button onClick={() => { setSuccessOpen(false); setRecibo(null); }} data-testid="valet-success-cerrar"
          className="btn-hard w-full h-12 bg-[#FFCC00] text-[#0A0A0A] border border-[#FFCC00] font-bold uppercase tracking-wider flex items-center justify-center gap-2">
          Aceptar y Cerrar
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default ReciboSuccessModal;
